import React, { useState, useEffect } from "react";
import API from "../../utils/API";

const MutualExclusivityTypeSelect = ({ name, value, onChange, required }) => {
    const [data, setData] = useState([]);

    useEffect(() => {
        API.get("/system/mutualexclusivitytypes").then((response) => {
            setData(response.data.data || []);
        });
    }, []);

    return (
        <select
            name={name}
            value={value}
            onChange={onChange}
            required={required}
            className="form-control"
        >
            <option value="">Exclusivity Type</option>
            {data.map((dataItem) => (
                <option key={dataItem.id} value={dataItem.id}>
                    {dataItem.title}
                </option>
            ))}
        </select>
    );
};

export default MutualExclusivityTypeSelect;
